var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4825 3.5C10.8225 3.5 3 11.34 3 21C3 30.66 10.8225 38.5 20.4825 38.5C30.16 38.5 38 30.66 38 21C38 11.34 30.16 3.5 20.4825 3.5ZM20.5 35C12.765 35 6.5 28.735 6.5 21C6.5 13.265 12.765 7 20.5 7C28.235 7 34.5 13.265 34.5 21C34.5 28.735 28.235 35 20.5 35ZM21.375 12.25H18.75V22.75L27.9375 28.2625L29.25 26.11L21.375 21.4375V12.25Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.d42bcde26a1f7cee492946d9c436fb20.svg";
export { ForwardRef as ReactComponent };